{
  "formatVersion": 1,
  "name": "blackline-dune-ii",
  "displayName": "DUNE II",
  "description": "A walled desert city at midday: a gated lane runs the full length of one flank to the terrace at A, a raised walk above the street climbs to it by a stair, the centre narrows through a double-door gate and a cedar arch, and a covered tunnel runs under the north houses to the court at B and its back platform.",
  "visual": {
    "gltf": "/game/maps/blackline-dune-ii.glb"
  },
  "environment": "day",
  "brushes": [
    {
      "kind": "box",
      "center": [
        0,
        -0.65,
        0
      ],
      "halfExtents": [
        56,
        0.6,
        53
      ],
      "material": "concrete",
      "note": "City foundation"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.05,
        0
      ],
      "halfExtents": [
        41,
        0.05,
        39
      ],
      "material": "sand",
      "note": "Street level"
    },
    {
      "kind": "box",
      "center": [
        -40,
        4.5,
        0
      ],
      "halfExtents": [
        0.6,
        4.5,
        39
      ],
      "material": "concrete",
      "note": "Outer city wall"
    },
    {
      "kind": "box",
      "center": [
        40,
        4.5,
        0
      ],
      "halfExtents": [
        0.6,
        4.5,
        39
      ],
      "material": "concrete",
      "note": "Outer city wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.5,
        38
      ],
      "halfExtents": [
        39.4,
        4.5,
        0.6
      ],
      "material": "concrete",
      "note": "Outer city wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.5,
        -38
      ],
      "halfExtents": [
        39.4,
        4.5,
        0.6
      ],
      "material": "concrete",
      "note": "Outer city wall"
    },
    {
      "kind": "box",
      "center": [
        -35,
        4.2,
        5
      ],
      "halfExtents": [
        4,
        4.2,
        24
      ],
      "material": "concrete",
      "note": "West perimeter homes"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3.9,
        13
      ],
      "halfExtents": [
        5,
        3.9,
        12
      ],
      "material": "plaster",
      "note": "Tunnel east block"
    },
    {
      "kind": "box",
      "center": [
        -9,
        4.35,
        -8.4
      ],
      "halfExtents": [
        5.5,
        4.35,
        5.6
      ],
      "material": "plaster",
      "note": "Mid west block"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3.75,
        -14
      ],
      "halfExtents": [
        5,
        3.75,
        3
      ],
      "material": "plaster",
      "note": "B connector block"
    },
    {
      "kind": "box",
      "center": [
        22,
        4.5,
        2
      ],
      "halfExtents": [
        6.5,
        4.5,
        15
      ],
      "material": "plaster",
      "note": "Long west homes"
    },
    {
      "kind": "box",
      "center": [
        6,
        2.85,
        -1
      ],
      "halfExtents": [
        1,
        2.85,
        11
      ],
      "material": "concrete",
      "note": "Catwalk divider"
    },
    {
      "kind": "box",
      "center": [
        19,
        3.5,
        23
      ],
      "halfExtents": [
        7,
        3.5,
        2.5
      ],
      "material": "plaster",
      "note": "Long gate west"
    },
    {
      "kind": "box",
      "center": [
        36,
        3.9,
        23
      ],
      "halfExtents": [
        3.5,
        3.9,
        2.5
      ],
      "material": "plaster",
      "note": "Long gate east"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3.5,
        33
      ],
      "halfExtents": [
        10.5,
        3.5,
        3
      ],
      "material": "plaster",
      "note": "T courtyard west"
    },
    {
      "kind": "box",
      "center": [
        23,
        4.05,
        33
      ],
      "halfExtents": [
        12,
        4.05,
        3
      ],
      "material": "plaster",
      "note": "T courtyard east"
    },
    {
      "kind": "box",
      "center": [
        -25,
        4.5,
        -34
      ],
      "halfExtents": [
        11,
        4.5,
        3
      ],
      "material": "plaster",
      "note": "B north houses"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.25,
        -35
      ],
      "halfExtents": [
        10,
        4.25,
        2
      ],
      "material": "plaster",
      "note": "CT north houses"
    },
    {
      "kind": "box",
      "center": [
        26,
        4.75,
        -35
      ],
      "halfExtents": [
        12,
        4.75,
        2
      ],
      "material": "plaster",
      "note": "A north houses"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.71,
        13
      ],
      "halfExtents": [
        3.5,
        0.275,
        12
      ],
      "material": "concrete",
      "note": "Tunnel roof south"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.71,
        -4
      ],
      "halfExtents": [
        3.5,
        0.275,
        5
      ],
      "material": "concrete",
      "note": "Tunnel roof north"
    },
    {
      "kind": "box",
      "center": [
        -18,
        4.7,
        0
      ],
      "halfExtents": [
        6,
        0.275,
        2.5
      ],
      "material": "concrete",
      "note": "Lower tunnel roof"
    },
    {
      "kind": "box",
      "center": [
        -29.95,
        0.875,
        24
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -24.05,
        0.875,
        24
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.8,
        24
      ],
      "halfExtents": [
        3.3,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "B tunnel header"
    },
    {
      "kind": "box",
      "center": [
        -29.95,
        0.875,
        9
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -24.05,
        0.875,
        9
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.8,
        9
      ],
      "halfExtents": [
        3.3,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "B tunnel header"
    },
    {
      "kind": "box",
      "center": [
        -29.95,
        0.875,
        -8
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -24.05,
        0.875,
        -8
      ],
      "halfExtents": [
        0.35,
        0.875,
        0.5
      ],
      "material": "concrete",
      "note": "B tunnel pier"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.8,
        -8
      ],
      "halfExtents": [
        3.3,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "B tunnel header"
    },
    {
      "kind": "box",
      "center": [
        -11.5,
        1.05,
        2.55
      ],
      "halfExtents": [
        0.5,
        1.05,
        0.35
      ],
      "material": "concrete",
      "note": "Lower tunnel exit pier"
    },
    {
      "kind": "box",
      "center": [
        -11.5,
        1.05,
        -2.55
      ],
      "halfExtents": [
        0.5,
        1.05,
        0.35
      ],
      "material": "concrete",
      "note": "Lower tunnel exit pier"
    },
    {
      "kind": "box",
      "center": [
        -11.5,
        4.75,
        0
      ],
      "halfExtents": [
        0.5,
        0.45,
        2.9
      ],
      "material": "plaster",
      "note": "Lower tunnel exit header"
    },
    {
      "kind": "box",
      "center": [
        -33,
        3,
        -10
      ],
      "halfExtents": [
        3.5,
        3,
        0.5
      ],
      "material": "concrete",
      "note": "B entry west"
    },
    {
      "kind": "box",
      "center": [
        -18,
        3,
        -10
      ],
      "halfExtents": [
        6,
        3,
        0.5
      ],
      "material": "concrete",
      "note": "B entry east"
    },
    {
      "kind": "box",
      "center": [
        -29.95,
        0.9,
        -10
      ],
      "halfExtents": [
        0.35,
        0.9,
        0.5
      ],
      "material": "concrete",
      "note": "B site entrance pier"
    },
    {
      "kind": "box",
      "center": [
        -24.05,
        0.9,
        -10
      ],
      "halfExtents": [
        0.35,
        0.9,
        0.5
      ],
      "material": "concrete",
      "note": "B site entrance pier"
    },
    {
      "kind": "box",
      "center": [
        -27,
        4.85,
        -10
      ],
      "halfExtents": [
        3.3,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "B site entrance header"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2.9,
        -19
      ],
      "halfExtents": [
        0.5,
        2.9,
        3
      ],
      "material": "concrete",
      "note": "B east enclosure south"
    },
    {
      "kind": "box",
      "center": [
        -12,
        2.9,
        -31
      ],
      "halfExtents": [
        0.5,
        2.9,
        3
      ],
      "material": "concrete",
      "note": "B east enclosure north"
    },
    {
      "kind": "box",
      "center": [
        -12,
        1.1,
        -22.15
      ],
      "halfExtents": [
        0.5,
        1.1,
        0.35
      ],
      "material": "concrete",
      "note": "B defender doors pier"
    },
    {
      "kind": "box",
      "center": [
        -12,
        1.1,
        -27.85
      ],
      "halfExtents": [
        0.5,
        1.1,
        0.35
      ],
      "material": "concrete",
      "note": "B defender doors pier"
    },
    {
      "kind": "box",
      "center": [
        -12,
        5.15,
        -25
      ],
      "halfExtents": [
        0.5,
        0.45,
        3.2
      ],
      "material": "plaster",
      "note": "B defender doors header"
    },
    {
      "kind": "box",
      "center": [
        -5.3,
        3.1,
        -16
      ],
      "halfExtents": [
        2.7,
        3.1,
        0.6
      ],
      "material": "concrete",
      "note": "Mid gate left"
    },
    {
      "kind": "box",
      "center": [
        5.3,
        3.1,
        -16
      ],
      "halfExtents": [
        2.7,
        3.1,
        0.6
      ],
      "material": "concrete",
      "note": "Mid gate right"
    },
    {
      "kind": "box",
      "center": [
        -2.95,
        1.4,
        -16
      ],
      "halfExtents": [
        0.35,
        1.4,
        0.5
      ],
      "material": "concrete",
      "note": "Mid double doors pier"
    },
    {
      "kind": "box",
      "center": [
        2.95,
        1.4,
        -16
      ],
      "halfExtents": [
        0.35,
        1.4,
        0.5
      ],
      "material": "concrete",
      "note": "Mid double doors pier"
    },
    {
      "kind": "box",
      "center": [
        0,
        5.85,
        -16
      ],
      "halfExtents": [
        3.3,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "Mid double doors header"
    },
    {
      "kind": "box",
      "center": [
        -1.8,
        1.9,
        -15.5
      ],
      "halfExtents": [
        0.625,
        1.9,
        0.125
      ],
      "material": "wood",
      "note": "Mid cedar door"
    },
    {
      "kind": "box",
      "center": [
        1.8,
        1.9,
        -16.5
      ],
      "halfExtents": [
        0.625,
        1.9,
        0.125
      ],
      "material": "wood",
      "note": "Mid cedar door"
    },
    {
      "kind": "box",
      "center": [
        25.95,
        1.35,
        23
      ],
      "halfExtents": [
        0.35,
        1.35,
        0.5
      ],
      "material": "concrete",
      "note": "Long A doors pier"
    },
    {
      "kind": "box",
      "center": [
        32.05,
        1.35,
        23
      ],
      "halfExtents": [
        0.35,
        1.35,
        0.5
      ],
      "material": "concrete",
      "note": "Long A doors pier"
    },
    {
      "kind": "box",
      "center": [
        29,
        5.85,
        23
      ],
      "halfExtents": [
        3.4,
        0.45,
        0.5
      ],
      "material": "plaster",
      "note": "Long A doors header"
    },
    {
      "kind": "box",
      "center": [
        27,
        1.85,
        22.2
      ],
      "halfExtents": [
        0.11,
        1.85,
        1.15
      ],
      "material": "wood",
      "note": "Long open gate"
    },
    {
      "kind": "box",
      "center": [
        31,
        1.85,
        22.2
      ],
      "halfExtents": [
        0.11,
        1.85,
        1.15
      ],
      "material": "wood",
      "note": "Long open gate"
    },
    {
      "kind": "box",
      "center": [
        24,
        0.9,
        -25
      ],
      "halfExtents": [
        12,
        0.9,
        6
      ],
      "material": "concrete",
      "note": "A terrace"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.9,
        -17
      ],
      "halfExtents": [
        2,
        0.9,
        8
      ],
      "material": "concrete",
      "note": "Short raised walk"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.075,
        -3.25
      ],
      "halfExtents": [
        2,
        0.075,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 1"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.075,
        -13.25
      ],
      "halfExtents": [
        3,
        0.075,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 1"
    },
    {
      "kind": "box",
      "center": [
        6.25,
        0.075,
        -29
      ],
      "halfExtents": [
        0.25,
        0.075,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 1"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.15,
        -3.75
      ],
      "halfExtents": [
        2,
        0.15,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 2"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.15,
        -13.75
      ],
      "halfExtents": [
        3,
        0.15,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 2"
    },
    {
      "kind": "box",
      "center": [
        6.75,
        0.15,
        -29
      ],
      "halfExtents": [
        0.25,
        0.15,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 2"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.225,
        -4.25
      ],
      "halfExtents": [
        2,
        0.225,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 3"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.225,
        -14.25
      ],
      "halfExtents": [
        3,
        0.225,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 3"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        0.225,
        -29
      ],
      "halfExtents": [
        0.25,
        0.225,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 3"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.3,
        -4.75
      ],
      "halfExtents": [
        2,
        0.3,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 4"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.3,
        -14.75
      ],
      "halfExtents": [
        3,
        0.3,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 4"
    },
    {
      "kind": "box",
      "center": [
        7.75,
        0.3,
        -29
      ],
      "halfExtents": [
        0.25,
        0.3,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 4"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.375,
        -5.25
      ],
      "halfExtents": [
        2,
        0.375,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 5"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.375,
        -15.25
      ],
      "halfExtents": [
        3,
        0.375,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 5"
    },
    {
      "kind": "box",
      "center": [
        8.25,
        0.375,
        -29
      ],
      "halfExtents": [
        0.25,
        0.375,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 5"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.45,
        -5.75
      ],
      "halfExtents": [
        2,
        0.45,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 6"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.45,
        -15.75
      ],
      "halfExtents": [
        3,
        0.45,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 6"
    },
    {
      "kind": "box",
      "center": [
        8.75,
        0.45,
        -29
      ],
      "halfExtents": [
        0.25,
        0.45,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 6"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.525,
        -6.25
      ],
      "halfExtents": [
        2,
        0.525,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 7"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.525,
        -16.25
      ],
      "halfExtents": [
        3,
        0.525,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 7"
    },
    {
      "kind": "box",
      "center": [
        9.25,
        0.525,
        -29
      ],
      "halfExtents": [
        0.25,
        0.525,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 7"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.6,
        -6.75
      ],
      "halfExtents": [
        2,
        0.6,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 8"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.6,
        -16.75
      ],
      "halfExtents": [
        3,
        0.6,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 8"
    },
    {
      "kind": "box",
      "center": [
        9.75,
        0.6,
        -29
      ],
      "halfExtents": [
        0.25,
        0.6,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 8"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.675,
        -7.25
      ],
      "halfExtents": [
        2,
        0.675,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 9"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.675,
        -17.25
      ],
      "halfExtents": [
        3,
        0.675,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 9"
    },
    {
      "kind": "box",
      "center": [
        10.25,
        0.675,
        -29
      ],
      "halfExtents": [
        0.25,
        0.675,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 9"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.75,
        -7.75
      ],
      "halfExtents": [
        2,
        0.75,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 10"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.75,
        -17.75
      ],
      "halfExtents": [
        3,
        0.75,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 10"
    },
    {
      "kind": "box",
      "center": [
        10.75,
        0.75,
        -29
      ],
      "halfExtents": [
        0.25,
        0.75,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 10"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.825,
        -8.25
      ],
      "halfExtents": [
        2,
        0.825,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 11"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.825,
        -18.25
      ],
      "halfExtents": [
        3,
        0.825,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 11"
    },
    {
      "kind": "box",
      "center": [
        11.25,
        0.825,
        -29
      ],
      "halfExtents": [
        0.25,
        0.825,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 11"
    },
    {
      "kind": "box",
      "center": [
        10,
        0.9,
        -8.75
      ],
      "halfExtents": [
        2,
        0.9,
        0.25
      ],
      "material": "concrete",
      "note": "Short stair step 12"
    },
    {
      "kind": "box",
      "center": [
        33,
        0.9,
        -18.75
      ],
      "halfExtents": [
        3,
        0.9,
        0.25
      ],
      "material": "concrete",
      "note": "Long stair step 12"
    },
    {
      "kind": "box",
      "center": [
        11.75,
        0.9,
        -29
      ],
      "halfExtents": [
        0.25,
        0.9,
        2
      ],
      "material": "concrete",
      "note": "CT stair step 12"
    },
    {
      "kind": "box",
      "center": [
        7.65,
        2.3,
        -16.5
      ],
      "halfExtents": [
        0.275,
        0.475,
        7.5
      ],
      "material": "concrete",
      "note": "Short parapet"
    },
    {
      "kind": "box",
      "center": [
        19,
        2.25,
        -18.8
      ],
      "halfExtents": [
        7,
        0.45,
        0.225
      ],
      "material": "concrete",
      "note": "A front parapet left"
    },
    {
      "kind": "box",
      "center": [
        -26,
        0.45,
        -28
      ],
      "halfExtents": [
        8,
        0.45,
        2.5
      ],
      "material": "concrete",
      "note": "B back platform"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.075,
        -23.25
      ],
      "halfExtents": [
        1.5,
        0.075,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.15,
        -23.65
      ],
      "halfExtents": [
        1.5,
        0.15,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.225,
        -24.05
      ],
      "halfExtents": [
        1.5,
        0.225,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.3,
        -24.45
      ],
      "halfExtents": [
        1.5,
        0.3,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.375,
        -24.85
      ],
      "halfExtents": [
        1.5,
        0.375,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.45,
        -25.25
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.2
      ],
      "material": "concrete",
      "note": "B platform stair"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.65,
        15
      ],
      "halfExtents": [
        3,
        0.65,
        0.3
      ],
      "material": "concrete",
      "note": "Pit cover"
    },
    {
      "kind": "box",
      "center": [
        25,
        2.5989999999999998,
        -23
      ],
      "halfExtents": [
        0.8089,
        0.789,
        0.8089
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        26.6,
        2.589,
        -23
      ],
      "halfExtents": [
        0.8089,
        0.789,
        0.8089
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        25,
        4.0112,
        -23
      ],
      "halfExtents": [
        0.6471,
        0.6312,
        0.6471
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        18,
        2.5679,
        -26
      ],
      "halfExtents": [
        0.9366,
        0.7679,
        0.9891
      ],
      "material": "wood",
      "note": "PACK pallet-loaded-01.glb"
    },
    {
      "kind": "box",
      "center": [
        31,
        2.3481,
        -28
      ],
      "halfExtents": [
        0.3935,
        0.5481,
        0.3408
      ],
      "material": "metal",
      "note": "PACK barrel-01.glb"
    },
    {
      "kind": "box",
      "center": [
        32,
        2.3481,
        -28
      ],
      "halfExtents": [
        0.3935,
        0.5481,
        0.3408
      ],
      "material": "metal",
      "note": "PACK barrel-02.glb"
    },
    {
      "kind": "box",
      "center": [
        -25,
        0.8285,
        -22
      ],
      "halfExtents": [
        0.8494,
        0.8285,
        0.8494
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -25,
        2.2902,
        -22
      ],
      "halfExtents": [
        0.6471,
        0.6312,
        0.6471
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -31,
        1.6088,
        -26
      ],
      "halfExtents": [
        0.8646,
        0.7088,
        0.913
      ],
      "material": "wood",
      "note": "PACK pallet-loaded-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -20,
        0.789,
        -20
      ],
      "halfExtents": [
        0.8089,
        0.789,
        0.8089
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -32,
        0.5481,
        -18
      ],
      "halfExtents": [
        0.3935,
        0.5481,
        0.3408
      ],
      "material": "metal",
      "note": "PACK barrel-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -31,
        0.5481,
        -18
      ],
      "halfExtents": [
        0.3935,
        0.5481,
        0.3408
      ],
      "material": "metal",
      "note": "PACK barrel-02.glb"
    },
    {
      "kind": "box",
      "center": [
        36,
        1.3032,
        19
      ],
      "halfExtents": [
        1.2273,
        1.3032,
        1.5697
      ],
      "material": "metal",
      "note": "PACK container-small-01.glb"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.5115,
        -7
      ],
      "halfExtents": [
        0.7819,
        0.5115,
        0.7819
      ],
      "material": "metal",
      "note": "PACK wirespool-01.glb"
    },
    {
      "kind": "box",
      "center": [
        2.8,
        0.5918,
        -10
      ],
      "halfExtents": [
        0.6067,
        0.5918,
        0.6067
      ],
      "material": "wood",
      "note": "PACK crate-large-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -7,
        0.7123,
        -23
      ],
      "halfExtents": [
        1.0049,
        0.7123,
        0.8393
      ],
      "material": "wood",
      "note": "PACK pallet-stack-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -29,
        0.3826,
        13
      ],
      "halfExtents": [
        0.8789,
        0.3826,
        0.5553
      ],
      "material": "wood",
      "note": "PACK crate-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -25,
        0.466,
        5
      ],
      "halfExtents": [
        0.4909,
        0.466,
        0.7261
      ],
      "material": "metal",
      "note": "PACK generator-01.glb"
    },
    {
      "kind": "box",
      "center": [
        35,
        0.3576,
        12
      ],
      "halfExtents": [
        0.5385,
        0.3576,
        0.366
      ],
      "material": "metal",
      "note": "PACK tire-stack-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.7088,
        28
      ],
      "halfExtents": [
        0.8646,
        0.7088,
        0.913
      ],
      "material": "wood",
      "note": "PACK pallet-loaded-01.glb"
    },
    {
      "kind": "box",
      "center": [
        -9,
        5.95,
        0
      ],
      "halfExtents": [
        5.5,
        2.75,
        2.8
      ],
      "material": "plaster",
      "note": "Lower Mid passage lintel"
    }
  ],
  "spawns": [
    {
      "position": [
        -6,
        0,
        29
      ],
      "yaw": -0.204,
      "team": 0
    },
    {
      "position": [
        -4,
        0,
        -30
      ],
      "yaw": -3.009,
      "team": 1
    },
    {
      "position": [
        -2,
        0,
        29
      ],
      "yaw": -0.069,
      "team": 0
    },
    {
      "position": [
        4,
        0,
        -30
      ],
      "yaw": 3.009,
      "team": 1
    },
    {
      "position": [
        2,
        0,
        29
      ],
      "yaw": 0.069,
      "team": 0
    },
    {
      "position": [
        7,
        0.45,
        -30
      ],
      "yaw": 2.912,
      "team": 1
    },
    {
      "position": [
        5,
        0,
        29
      ],
      "yaw": 0.171,
      "team": 0
    },
    {
      "position": [
        -6,
        0,
        -32
      ],
      "yaw": -2.956,
      "team": 1
    },
    {
      "position": [
        -4,
        0,
        27
      ],
      "yaw": -0.147,
      "team": 0
    },
    {
      "position": [
        -6,
        0,
        -28
      ],
      "yaw": -2.93,
      "team": 1
    },
    {
      "position": [
        -1,
        0,
        0
      ],
      "yaw": -0.147,
      "team": 0
    },
    {
      "position": [
        -2.5,
        0,
        -1.5
      ],
      "yaw": -0.147,
      "team": 0
    },
    {
      "position": [
        -2.5,
        0,
        1.5
      ],
      "yaw": -0.147,
      "team": 0
    },
    {
      "position": [
        0.5,
        0,
        -1.5
      ],
      "yaw": -0.147,
      "team": 1
    },
    {
      "position": [
        0.5,
        0,
        1.5
      ],
      "yaw": -0.147,
      "team": 1
    },
    {
      "position": [
        -4,
        0,
        0
      ],
      "yaw": -0.147,
      "team": 1
    }
  ],
  "props": [],
  "lights": [
    {
      "kind": "point",
      "position": [
        -25,
        2.9,
        2
      ],
      "color": "#ffc078",
      "intensity": 25,
      "distance": 9
    },
    {
      "kind": "point",
      "position": [
        -27,
        2.9,
        -5
      ],
      "color": "#ffc078",
      "intensity": 25,
      "distance": 9
    },
    {
      "kind": "point",
      "position": [
        0,
        4.199999999999999,
        -15
      ],
      "color": "#ffc078",
      "intensity": 25,
      "distance": 9
    },
    {
      "kind": "point",
      "position": [
        29,
        4.5,
        23
      ],
      "color": "#ffc078",
      "intensity": 25,
      "distance": 9
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        25,
        2.02,
        -25
      ],
      "halfExtents": [
        4,
        0.5,
        3.5
      ]
    },
    {
      "id": "B",
      "center": [
        -25,
        0.22,
        -22
      ],
      "halfExtents": [
        4,
        0.5,
        3.5
      ]
    }
  ]
}
